import {
  ActionLogsListViewComponent,
  CustomerProfilesListViewComponent,
  ForgotPasswordViewComponent,
  LoginViewComponent,
  MeetingAvailabilitiesListViewComponent,
  MeetingTypesListViewComponent,
  OfferedServicesListViewComponent,
  OrderCardAttributeTypesListViewComponent,
  OrdersListViewComponent,
  OrderSourcesListViewComponent,
  OrderStatusesListViewComponent,
  PrivacyPolicyViewComponent,
  ResetPasswordViewComponent,
  ScheduledMeetingsListViewComponent,
  StaffProfilesListViewComponent,
  TermsOfServiceViewComponent,
} from '@aa/angular/core';
import {
  AdminJobsViewComponent,
  OrderDetailViewComponent,
} from '@aa/angular/staff';
import { CanDeactivateFn, Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: 'login',
    component: LoginViewComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordViewComponent,
  },
  {
    path: 'reset-password/:userId/:token',
    component: ResetPasswordViewComponent,
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceViewComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyViewComponent,
  },
  {
    path: '',
    redirectTo: 'orders',
    pathMatch: 'full',
  },
  {
    path: 'orders',
    component: OrdersListViewComponent,
  },
  {
    path: 'orders/:id',
    component: OrderDetailViewComponent,
    canDeactivate: [
      ((component: OrderDetailViewComponent) =>
        component.canDeactivate()) as CanDeactivateFn<OrderDetailViewComponent>,
    ],
  },
  {
    path: 'customers',
    component: CustomerProfilesListViewComponent,
  },
  {
    path: 'staff',
    component: StaffProfilesListViewComponent,
  },
  {
    path: 'offered-services',
    component: OfferedServicesListViewComponent,
  },
  {
    path: 'order-statuses',
    component: OrderStatusesListViewComponent,
  },
  {
    path: 'order-sources',
    component: OrderSourcesListViewComponent,
  },
  {
    path: 'order-card-attribute-types',
    component: OrderCardAttributeTypesListViewComponent,
  },
  {
    path: 'meeting-types',
    component: MeetingTypesListViewComponent,
  },
  {
    path: 'meetings',
    component: ScheduledMeetingsListViewComponent,
  },
  {
    path: 'meeting-availability',
    component: MeetingAvailabilitiesListViewComponent,
  },
  {
    path: 'action-logs',
    component: ActionLogsListViewComponent,
  },
  {
    path: 'admin-jobs',
    component: AdminJobsViewComponent,
  },
];
